<div id="dashboard-project" class="page-layout simple right-sidebar" fxLayout="row">
    <!-- CENTER -->
    <div class="center" fusePerfectScrollbar>

        <!-- HEADER -->
        <div class="header accent p-24 pb-0" fxLayout="column" fxLayoutAlign="space-between">
            <div fxLayout="row" fxLayoutAlign="space-between start">
                <span 
                    class="mat-display-1 my-0 my-sm-24 welcome-message" 
                    [@animate]="{value:'*',params:{x:'50px'}}">
                    Dashboard COE
                </span>
            </div>            
        </div>
        <!-- / HEADER -->

        <div class="content">
            <div dynamicHeight>
                <mat-card>
                    <!-- Filtros -->
                    <mat-card-header>
                        <div 
                            class="pl-16 pr-8 py-16 h-52" 
                            fxLayout="row"
                            fxLayoutAlign="space-between center"
                            *ngIf="this.user.role_id == 7 || this.user.role_id == 4 || this.user.role_id == 1 || this.user.role_id == 2 ">
                            <mat-label>Regional:</mat-label>
                            <mat-form-field style="margin-left: 5px;">
                                <mat-select 
                                    class="simplified font-size-16"
                                    aria-label="Change range"
                                    [(ngModel)]="model.regional_id"
                                    [formControl]="regional_id"
                                    (selectionChange)="selectRegional($event)">                            
                                    <mat-option 
                                        *ngFor="let regional of listRegional"
                                        [value]="regional.id">
                                        {{regional.nome}}
                                    </mat-option>                            
                                </mat-select>
                                <mat-spinner diameter="20" *ngIf="loadingSpinnerRegional"></mat-spinner>
                            </mat-form-field>            
                        </div> 

                        <div
                            class="pl-16 pr-8 py-16 h-52" 
                            fxLayout="row"
                            fxLayoutAlign="space-between center"
                            *ngIf="this.user.role_id == 7 || this.user.role_id == 4 || this.user.role_id == 1 || this.user.role_id == 2 || user.tipo_usuario_id == 3">
                            <mat-label>Escritório:</mat-label>
                            <mat-form-field style="margin-left: 5px;">
                                <mat-select 
                                    class="simplified font-size-16"
                                    aria-label="Change range"
                                    [(ngModel)]="model.escritorio_id"
                                    [formControl]="escritorio_id"
                                    (selectionChange)="selectEscritorio($event)">
                                    <mat-option 
                                        *ngFor="let escritorio of listEscritorio"
                                        [value]="escritorio.id">
                                        {{escritorio.nome_fantasia}}
                                    </mat-option>                            
                                </mat-select>
                                <mat-spinner diameter="20" *ngIf="loadingSpinnerEscritorio"></mat-spinner>
                            </mat-form-field>            
                        </div>
                        
                        <div 
                            class="pl-16 pr-8 py-16 h-52" 
                            fxLayout="row"
                            fxLayoutAlign="space-between center"
                            *ngIf="this.user.role_id != 5">
                            <mat-label>Assessor:</mat-label>
                            <mat-form-field>                   
                                <mat-select 
                                    class="simplified font-size-16"
                                    aria-label="Change range"
                                    [formControl]="assessor_id"
                                    (selectionChange)="selectAssessor($event)">
                                    <mat-option value="">TODOS</mat-option>
                                    <mat-optgroup 
                                        *ngFor="let escritorio of listEscritorio" 
                                        [label]="escritorio.nome_fantasia">
                                        <mat-option 
                                        *ngFor="let usuario of escritorio.usuarios" 
                                        [value]="usuario.id">
                                        {{usuario.name}}
                                        </mat-option>
                                    </mat-optgroup>
                                </mat-select>
                                <mat-spinner diameter="20" *ngIf="loadingSpinnerAssessor"></mat-spinner>
                            </mat-form-field>
                        </div>              
                        
                    </mat-card-header>
                    <!-- / Filtros -->
                    
                    <mat-card-content>
                        <div 
                            class="widget-group p-12" 
                            fxLayout="row wrap" 
                            fxFlex="100"                             
                            [@animateStagger]="{value:'50'}"
                        > 

                            <!-- Total Clientes -->
                             <!-- // todo: verificar -->
                            <!-- <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                [shape]="'square'"
                                [width]="'90%'"
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"                     
                                fxFlex.gt-md="33"
                                *ngIf="loadingIndicator"
                            >
                            </ngx-shimmer-loading> -->

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!loadingIndicator"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">  
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Clientes</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>                                      
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            style="cursor: pointer;"
                                            (click)="getListaClienteExport('ALL')"
                                        >
                                            {{total_clientes.conversion.value}}
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Total de Clientes
                                        </div>
                                    </div>
                                    <div class="h-96 w-100-p">
                                        <!--todo: verificar-->
                                        <!-- <canvas 
                                            baseChart
                                            [datasets]="total_clientes.datasets"
                                            [labels]="total_clientes.labels"
                                            [colors]="colors"
                                            [options]="total_clientes.options"
                                            [chartType]="total_clientes.chartType"
                                            >
                                        </canvas> -->
                                    </div>
                                </div>

                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                            aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        <span>
                                            Total de Clientes 
                                            que tem COE sobre custódia.
                                            Contém também histórico dos últimos 5 meses.
                                        </span>

                                        <span>
                                            Data da última atualização:
                                            {{ date_last_operation | date:'dd/MM/yyyy'}}
                                        </span>
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Total Clientes -->

                            <!-- Total Novos clienes -->
                             <!-- // todo: verificar -->
                            <!-- <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                [shape]="'square'"
                                [width]="'90%'"
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"                     
                                fxFlex.gt-md="33"
                                *ngIf="loadingIndicator"
                            >
                            </ngx-shimmer-loading> -->

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!loadingIndicator"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">  
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Clientes</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>                                      
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            style="cursor: pointer;"
                                            (click)="getListaClienteExport('NEW')"
                                        >
                                            {{total_novos_clientes.conversion.value}}
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Total de Novos Clientes
                                        </div>
                                    </div>
                                    <div class="h-96 w-100-p">
                                        <!--todo: verificar-->
                                        <!-- <canvas 
                                            baseChart
                                            [datasets]="total_novos_clientes.datasets"
                                            [labels]="total_novos_clientes.labels"
                                            [colors]="colors"
                                            [options]="total_novos_clientes.options"
                                            [chartType]="total_novos_clientes.chartType"
                                            >
                                        </canvas> -->
                                    </div>
                                </div>

                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                            aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        <span>
                                            Total de clientes 
                                            que adquiriram COE na custodia
                                            e não tinha custódia nos meses anteriores.
                                            Contém também histórico dos últimos 5 meses.
                                        </span> 

                                        <span>
                                            Data da última atualização:
                                            {{ date_last_operation | date:'dd/MM/yyyy'}}
                                        </span>
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Total Novos clienes -->

                            <!-- Total Percentual COE -->
                             <!-- // todo: verificar -->
                            <!-- <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                [shape]="'square'"
                                [width]="'90%'"
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"                     
                                fxFlex.gt-md="33"
                                *ngIf="loadingIndicator"
                            >
                            </ngx-shimmer-loading> -->

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!loadingIndicator"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">    
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Clientes</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>                                  
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            style="cursor: pointer;">
                                            {{formataCasaDecimal(total_percentual_clientes.conversion.value) | number : '1.2-2'}}%
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Percentual de Clientes
                                        </div>
                                    </div>
                                    <div class="h-96 w-100-p">
                                        <!--todo: verificar-->
                                        <!-- <canvas 
                                            baseChart
                                            [datasets]="total_percentual_clientes.datasets"
                                            [labels]="total_percentual_clientes.labels"
                                            [colors]="colors"
                                            [options]="total_percentual_clientes.options"
                                            [chartType]="total_percentual_clientes.chartType"
                                            >
                                        </canvas> -->
                                    </div>
                                </div>
                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                            aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        <span>
                                            Percentual de clientes que possuem COE
                                            sobre custódia comparado ao total de clientes
                                            da sua carteira. 
                                            Contém também histórico dos últimos 5 meses.
                                        </span>

                                        <span>
                                            Data da última atualização:
                                            {{ date_last_operation | date:'dd/MM/yyyy'}}
                                        </span>
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Total Percentual RF -->

                            <!-- Total Custódia -->
                            <!-- <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                [shape]="'square'"
                                [width]="'90%'"
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"                     
                                fxFlex.gt-md="33"
                                *ngIf="loadingIndicator"
                            >
                            </ngx-shimmer-loading> -->

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!loadingIndicator"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">    
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Custódia</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>                                  
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            style="cursor: pointer;"
                                            (click)="getListaCustodiaExport('ALL')"
                                        >
                                            R${{total_custodia.conversion.value | number : '1.2-2'}}
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Total de Custódia
                                        </div>
                                    </div>
                                    <div class="h-96 w-100-p">
                                        <!--todo: verificar-->
                                        <!-- <canvas 
                                            baseChart
                                            [datasets]="total_custodia.datasets"
                                            [labels]="total_custodia.labels"
                                            [colors]="colors"
                                            [options]="total_custodia.options"
                                            [chartType]="total_custodia.chartType"
                                            >
                                        </canvas> -->
                                    </div>
                                </div>
                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                            aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        <span>
                                            Total financeiro
                                            de custodia de COE da sua base total
                                            de clientes.
                                            Contém também histórico dos últimos 5 meses.
                                        </span>

                                        <span>
                                            Data da última atualização:
                                            {{ date_last_operation | date:'dd/MM/yyyy'}}
                                        </span>
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Total Custódia -->

                            <!-- Total Custódia por vencimento -->

                            <!-- <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                [shape]="'square'"
                                [width]="'90%'"
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"                     
                                fxFlex.gt-md="33"
                                *ngIf="loadingIndicator"
                            >
                            </ngx-shimmer-loading> -->

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!loadingIndicator"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">    
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Custódia</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>                                  
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            style="cursor: pointer;"
                                            (click)="getListaCustodiaExport('EXPIRED')"
                                        >
                                            R${{formataCasaDecimal(total_custodia_por_vencimento.conversion.value) | number : '1.2-2'}}
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Por Vencimento
                                        </div>
                                    </div>
                                    <div class="h-96 w-100-p">
                                        <!--todo: verificar-->
                                        <!-- <canvas 
                                            baseChart
                                            [datasets]="total_custodia_por_vencimento.datasets"
                                            [labels]="total_custodia_por_vencimento.labels"
                                            [colors]="colors"
                                            [options]="total_custodia_por_vencimento.options"
                                            [chartType]="total_custodia_por_vencimento.chartType"
                                            >
                                        </canvas> -->
                                    </div>
                                </div>
                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                            aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        <span>
                                            Total de custódia de COE
                                            que vão vencer no mes atual
                                            ou tem uma data de observação informada.

                                            Contém também histórico dos últimos 5 meses.
                                        </span>

                                        <span>
                                            Data da última atualização:
                                            {{ date_last_operation | date:'dd/MM/yyyy'}}
                                        </span>
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Total Custódia por vencimento -->

                            <!-- Percentual de Custódia RF -->
                            <!-- <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                [shape]="'square'"
                                [width]="'90%'"
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"                     
                                fxFlex.gt-md="33"
                                *ngIf="loadingIndicator"
                            >
                            </ngx-shimmer-loading> -->

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!loadingIndicator"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">    
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Custódia</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>                                  
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            style="cursor: pointer;">
                                            {{formataCasaDecimal(total_percentual_custodia.conversion.value) | number : '1.2-2' }}%
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Percentual COE
                                        </div>
                                    </div>
                                    <div class="h-96 w-100-p">
                                        <!--todo: verificar-->
                                        <!-- <canvas 
                                            baseChart
                                            [datasets]="total_percentual_custodia.datasets"
                                            [labels]="total_percentual_custodia.labels"
                                            [colors]="colors"
                                            [options]="total_percentual_custodia.options"
                                            [chartType]="total_percentual_custodia.chartType"
                                            >
                                        </canvas> -->
                                    </div>
                                </div>
                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                            aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        <span>
                                            Percentual da custódia de COE
                                            da sua carteira de clientes.
                                            Contém também histórico dos últimos 5 meses.
                                        </span>

                                        <span>
                                            Data da última atualização:
                                            {{ date_last_operation | date:'dd/MM/yyyy'}}
                                        </span>
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Percentual de Custódia RF -->

                            <!-- Boleta Total -->
                            <!-- <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                [shape]="'square'"
                                [width]="'90%'"
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"                     
                                fxFlex.gt-md="33"
                                *ngIf="loadingIndicator"
                            >
                            </ngx-shimmer-loading> -->

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!loadingIndicator"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">    
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Boleta</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>                                  
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            style="cursor: pointer;">
                                            R${{total_boleta.conversion.value | number : '1.2-2'}}
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Total Boleta
                                        </div>
                                    </div>
                                    <div class="h-96 w-100-p">
                                        <!--todo: verificar-->
                                        <!-- <canvas 
                                            baseChart
                                            [datasets]="total_boleta.datasets"
                                            [labels]="total_boleta.labels"
                                            [colors]="colors"
                                            [options]="total_boleta.options"
                                            [chartType]="total_boleta.chartType"
                                            >
                                        </canvas> -->
                                    </div>
                                </div>
                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                            aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        <span>
                                            Valor total de boletas cadastradas
                                            de COE.
                                            Contém também histórico dos últimos 5 meses.
                                        </span>

                                        <span>
                                            Data da última atualização:
                                            {{ date_last_operation | date:'dd/MM/yyyy'}}
                                        </span>
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Boleta Total -->

                            <!-- Total Boleta Efetivada -->
                             <!-- // todo: verificar -->
                            <!-- <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                [shape]="'square'"
                                [width]="'90%'"
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"                     
                                fxFlex.gt-md="33"
                                *ngIf="loadingIndicator"
                            >
                            </ngx-shimmer-loading> -->

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!loadingIndicator"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">    
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Boleta</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>                                  
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            style="cursor: pointer;">
                                            R${{total_boleta_efetivada.conversion.value | number : '1.2-2'}}
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Total Boleta Efetivada
                                        </div>
                                    </div>
                                    <div class="h-96 w-100-p">
                                        <!--todo: verificar-->
                                        <!-- <canvas 
                                            baseChart
                                            [datasets]="total_boleta_efetivada.datasets"
                                            [labels]="total_boleta_efetivada.labels"
                                            [colors]="colors"
                                            [options]="total_boleta_efetivada.options"
                                            [chartType]="total_boleta_efetivada.chartType"
                                            >
                                        </canvas> -->
                                    </div>
                                </div>
                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                            aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        <span>
                                            Valor total de boletas efetivadas.
                                            Contém também histórico dos últimos 5 meses.
                                        </span>

                                        <span>
                                            Data da última atualização:
                                            {{ date_last_operation | date:'dd/MM/yyyy'}}
                                        </span>
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Total Boleta Efetivada -->

                            <!-- Total Boleta Cancelada -->
                             <!-- // todo: verificar -->
                            <!-- <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                [shape]="'square'"
                                [width]="'90%'"
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"                     
                                fxFlex.gt-md="33"
                                *ngIf="loadingIndicator"
                            >
                            </ngx-shimmer-loading> -->

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!loadingIndicator"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">    
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Boleta</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>                                  
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            style="cursor: pointer;">
                                            {{total_boleta_cancelada.conversion.value}}
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Total Boleta Cancelada
                                        </div>
                                    </div>
                                    <div class="h-96 w-100-p">
                                        <!--todo: verificar-->
                                        <!-- <canvas 
                                            baseChart
                                            [datasets]="total_boleta_cancelada.datasets"
                                            [labels]="total_boleta_cancelada.labels"
                                            [colors]="colors"
                                            [options]="total_boleta_cancelada.options"
                                            [chartType]="total_boleta_cancelada.chartType"
                                            >
                                        </canvas> -->
                                    </div>
                                </div>
                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button 
                                        mat-icon-button 
                                        fuseWidgetToggle 
                                        class="fuse-widget-flip-button"
                                        aria-label="Flip widget"
                                    >
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        <span>
                                            Valor total de boletas canceladas.
                                            Contém também histórico dos últimos 5 meses.
                                        </span> 

                                        <span>
                                            Data da última atualização:
                                            {{ date_last_operation | date:'dd/MM/yyyy'}}
                                        </span>
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Total Boleta Cancelada -->                            

                            <!-- Pendencias Inconsistencias -->
                             <!-- // todo: verificar -->
                            <!-- <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                [shape]="'square'"
                                [width]="'90%'"
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"                     
                                fxFlex.gt-md="33"
                                *ngIf="loadingIndicator"
                            >
                            </ngx-shimmer-loading> -->

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!loadingIndicator"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">    
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Gestão</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>                                  
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            style="cursor: pointer;">
                                            {{total_pendencias_inconsistencias.conversion.value}}
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Pendências Inconsistências
                                        </div>
                                    </div>
                                    <div class="h-96 w-100-p">
                                        <!--todo: verificar-->
                                        <!-- <canvas 
                                            baseChart
                                            [datasets]="total_pendencias_inconsistencias.datasets"
                                            [labels]="total_pendencias_inconsistencias.labels"
                                            [colors]="colors"
                                            [options]="total_pendencias_inconsistencias.options"
                                            [chartType]="total_pendencias_inconsistencias.chartType"
                                            >
                                        </canvas> -->
                                    </div>
                                </div>
                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                            aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        <span>
                                            Total de boletas com pendências e 
                                            inconsistências.
                                            Contém também histórico dos últimos 5 meses.
                                        </span> 

                                        <span>
                                            Data da última atualização:
                                            {{ date_last_operation | date:'dd/MM/yyyy'}}
                                        </span>
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Pendencias Inconsistencias -->

                            <!-- ROA -->
                             <!-- // todo: verificar -->
                            <!-- <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                [shape]="'square'"
                                [width]="'90%'"
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"                     
                                fxFlex.gt-md="33"
                                *ngIf="loadingIndicator"
                            >
                            </ngx-shimmer-loading> -->

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!loadingIndicator"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">    
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Gestão</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>                                  
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            style="cursor: pointer;">
                                            {{formataCasaDecimal(roa.conversion.value) | number : '1.2-2' }}%
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            ROA
                                        </div>
                                    </div>
                                    <div class="h-96 w-100-p">
                                        <!--todo: verificar-->
                                        <!-- <canvas 
                                            baseChart
                                            [datasets]="roa.datasets"
                                            [labels]="roa.labels"
                                            [colors]="colors"
                                            [options]="roa.options"
                                            [chartType]="roa.chartType"
                                            >
                                        </canvas> -->
                                    </div>
                                </div>
                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                            aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        <span>
                                            ROA do COE da sua carteira de clientes.
                                            Contém também histórico dos últimos 5 meses.
                                        </span>

                                        <span>
                                            Data da última atualização:
                                            {{ date_last_operation | date:'dd/MM/yyyy'}}
                                        </span>
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / ROA -->
                            
                            <!-- Total Receita Estimada -->
                             <!-- // todo: verificar -->
                            <!-- <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                [shape]="'square'"
                                [width]="'90%'"
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"                     
                                fxFlex.gt-md="33"
                                *ngIf="loadingIndicator"
                            >
                            </ngx-shimmer-loading> -->

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!loadingIndicator"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">    
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Gestão</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>                                  
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            style="cursor: pointer;">
                                            R${{ total_receita_estimada.conversion.value | number : '1.2-2' }}
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Projeção de Receita
                                        </div>
                                    </div>
                                    <div class="h-96 w-100-p">
                                        <!--todo: verificar-->
                                        <!-- <canvas 
                                            baseChart
                                            [datasets]="total_receita_estimada.datasets"
                                            [labels]="total_receita_estimada.labels"
                                            [colors]="colors"
                                            [options]="total_receita_estimada.options"
                                            [chartType]="total_receita_estimada.chartType"
                                            >
                                        </canvas> -->
                                    </div>
                                </div>
                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button 
                                        mat-icon-button 
                                        fuseWidgetToggle 
                                        class="fuse-widget-flip-button"
                                        aria-label="Flip widget"
                                    >
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        <span>
                                            Receita estimada bruta das operações
                                            de COE dos seus clientes.
                                            Contém também histórico dos últimos 5 meses.
                                        </span>

                                        <span>
                                            Data da última atualização:
                                            {{ date_last_operation | date:'dd/MM/yyyy'}}
                                        </span>
                                        
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Total Receita Estimada -->
                            
                        </div>
                    </mat-card-content>    
                </mat-card>
            </div>
        </div>
    </div>
</div>
